<template>
  <div class="page-con">
    <div class="page-con-header clearfix">
      <Button status="primary" icon="ios-add" style="margin-left: 10px" @click="showTempModal"
      >导入轨迹校验
      </Button>

      <Button icon="md-download" type="primary" @click="download" style="margin-left: 10px">
        导出轨迹校验
      </Button>

      <Button status="primary" @click="check" style="margin-left: 10px">
        立即校验
      </Button>

      <span class="finance-span finance-span-time" style="margin-left: 10px">
        <vxe-input
            v-model="keyword"
            style="margin-right: 10px"
            type="input"
            placeholder="车牌号"
            clearable
        ></vxe-input>

        <label>选择时间:</label>
        <el-date-picker
            v-model="startTime"
            type="datetime"
            placeholder="请选择开始日期"
            style="width:192px;height: 30px;"
        >
        </el-date-picker>
        <i class="line-icon">--</i>
        <el-date-picker
            v-model="endTime"
            type="datetime"
            placeholder="请选择结束日期"
            style="width:192px;"
        >
        </el-date-picker>
        <Select
            style="width: 200px;margin-left: 10px;"
            v-model="createUserId"
            clearable
            :remote-method="(query) => getCreateUserOptions(query)"
            :default-label="[]"
            :loading="searchLoading"
            :max-tag-count="1"
            placeholder="选择创建人"
        >
          <Option
              v-for="option in createUserOptions"
              :value="option.createUserId"
              :key="option.createUserId"
          >{{ option.createUser }}
          </Option>
        </Select>
      </span>

      <Button
          status="primary"
          icon="ios-search"
          @click="getList"
          style="border-radius: 5px;margin-left: 10px;"
      >搜索
      </Button>

      <vxe-button icon="vxe-icon--refresh" @click="refresh" style="margin-left: 10px">
        刷新
      </vxe-button>
    </div>
    <div class="list-box common-shadow clearfix">
      <vxe-table
          ref="xTable"
          class="table-style"
          highlight-hover-row
          show-footer
          stripe
          align="center"
          border="none"
          max-height="600"
          :data="tableData"
          :loading="loading"
          :footer-method="footerMethod"
      >
        <vxe-table-column field="id" title="序号" width="90"></vxe-table-column>
        <vxe-table-column
            field="carNum"
            title="车牌号"
            width="100"
            show-overflow
        ></vxe-table-column>
        <vxe-table-column field="vco" title="车牌颜色" width="100" show-overflow>
          <template slot-scope="{ row }">
            <span>{{ row.vco | carCorlorMap }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="trackUrl" title="轨迹" width="80" show-overflow>
          <template slot-scope="{ row }">
            <div style="display: flex;align-items: center;justify-content:center;">
              <img
                  v-if="row.trackUrl"
                  style="width: 20px;height: 20px;"
                  src="@/assets/images/common/icon-guiji.png"
                  @click="seeCarMap(row)"
              />
              <img
                  v-else
                  style="width: 20px;height: 20px;"
                  src="@/assets/images/common/icon-noguiji.png"
              />
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column
            field="beginPlace"
            title="起运地"
            width="200"
            show-overflow
        ></vxe-table-column>
        <vxe-table-column field="beginTime" title="起运时间" width="180">
          <template slot-scope="{ row }">
            <span>{{ row.beginTime | timeFormat }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column
            field="endPlace"
            title="目的地"
            width="200"
            show-overflow
        ></vxe-table-column>
        <vxe-table-column field="endTime" title="到达时间" width="180">
          <template slot-scope="{ row }">
            <span>{{ row.endTime | timeFormat }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="checkStatus" title="轨迹匹配" width="100" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.checkStatus | LogisticsCheckStatusMap }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="checkBeginStatus" title="起运地匹配" width="100" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.checkBeginStatus | LogisticsCheckStatusMap }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="checkEndStatus" title="到达地匹配" width="100" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.checkEndStatus | LogisticsCheckStatusMap }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="createUser" title="创建人" width="100"></vxe-table-column>
        <vxe-table-column field="createTime" title="创建时间" width="180">
          <template slot-scope="{ row }">
            <span>{{ row.createTime | timeFormat }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="isChangeTime" title="是否系统更新时间" width="180">
          <template slot-scope="{ row }">
            <span>{{ row.isChangeTime === 1 ? "是" : "否" }}</span>
          </template>
        </vxe-table-column>
      </vxe-table>
      <vxe-pager
          background
          size="small"
          :current-page.sync="page.currentPage"
          :page-size.sync="page.pageSize"
          :total="page.totalResult"
          @page-change="changePage"
      ></vxe-pager>
    </div>
    <div v-show="trackFlag" class="trackBox">
      <div style="display: flex;justify-content: space-between;">
        <div style="margin-left: 10px;font-size: 14px;font-weight: bold;line-height: 30px;">
          {{ isCar ? "车辆轨迹" : "船舶轨迹" }}
        </div>
        <div
            @click="trackFlag = false"
            style="margin-right:5px;cursor: pointer;line-height: 30px;height: 30px;background: #409EFF;color: #fff;border-radius:5px;width:60px;font-size: 12px;font-size: 12px;text-align: center;"
        >
          关闭
        </div>
      </div>
      <iframe
          ref="mapFrame"
          style="width:100%;height:85vh;overflow: hidden;"
          frameborder="0"
          name="showHere"
          scrolling="auto"
          :src="url"
      ></iframe>
    </div>

    <vxe-modal
        v-model="templateVisible"
        title="轨迹校验导入"
        width="1000"
        height="620"
        @close="closeTemplate"
        position="center"
    >
      <import @goImport="impotEvent" @close="closeTemplate" ref="modalTemplate"></import>
    </vxe-modal>

    <div class="search-filter">
      <vxe-modal
          class="timeModal"
          v-model="open"
          width="460"
          height="400"
          :show-footer="false"
          :showHeader="false"
      >
        <template v-slot>
          <DatePicker
              :open="open"
              confirm
              type="daterange"
              :split-panels="true"
              placeholder
              style="width: 432px"
              @on-change="handleChange"
              @on-clear="handleClear"
              @on-ok="handleOk"
          >
            <span class="date-slot"></span>
          </DatePicker>
        </template>
      </vxe-modal>
    </div>
  </div>
</template>

<script>
import XLSX from "xlsx";
import $C from "@/consts/index";
import $api from "@/apiProvider";
import moment from "moment";
import Import from "@/components/common/Import"; // 导入
import getAuthOrization from "@/mixin/getAuthOrization";
import {
  getExcelDateHMTimeCheckStart,
  getExcelDateHMTimeCheckEnd,
  getBlob,
  hideLoading,
  isEmpty,
  saveBlob,
  showLoading,
  isNotEmpty,
  postBlob,
} from "@/utils/util";
import viewOrderDetail from "@/mixin/viewOrderDetail";
import {SEARCH_TIME} from "@/filters/time";

export default {
  name: "Logistics",
  components: {Import},
  mixins: [viewOrderDetail, getAuthOrization],
  data() {
    return {
      createCarVisible: false,
      createShipVisible: false,
      createCarTitle: "",
      createShipTitle: "",
      loading: false,
      searchLoading: false,
      searchVisible: false,
      open: false,
      trackFlag: false,
      url: "",
      isCar: true,
      tableData: [],
      countData: {
        noTrack: 0,
        checkOk: 0,
      },
      shipObj: {},
      startTime: "",
      endTime: "",

      paramsObj: {
        orderBy: 6,
        isDesc: 1,
        pageNum: 1,
        pageSize: 10,
      },

      page: {
        currentPage: 1,
        pageSize: 10,
        totalResult: 100,
      },
      title: "",
      totalCounts: 0,
      totalRealCounts: 0,
      visible: false,
      detailVisible: false,
      updateVisible: false,
      templateVisible: false,

      searchFormData: {
        createTime: null,
      },
      timeOptions: SEARCH_TIME.options,
      interval: null,
      createUserOptions: [],
      createUserId: null,
      keyword: null
    };
  },
  mounted() {
    this.startTime = moment()
        .startOf("day")
        .format("YYYY-MM-DD HH:mm:ss");
    this.endTime = moment()
        .endOf("day")
        .format("YYYY-MM-DD HH:mm:ss");
    this.getCreateUserOptions(null);
    this.getList();
  },
  methods: {
    //校验轨迹
    async check() {
      let res = await $api.logistics.post("check/check");
      this.$XModal.alert({
        message: "已开始核验: " + res.data + "条",
        status: "success",
      });
      var that = this;

      if (isNotEmpty(this.interval)) {
        clearInterval(this.interval);
      }
      this.interval = setInterval(function () {
        that.$XModal.close();
        that.getList(true);
      }, 30000);
    },
    search() {
      this.page.currentPage = 1;
      this.page.pageSize = 10;
      this.searchVisible = false;
      this.getList();
    },
    reset() {
      this.searchFormData = {
        logisticsNum: null,
      };
    },
    openRangeDate(field) {
      if (this.searchFormData[field] === 1) {
        this.rangeTime = field;
        this.open = true;
      } else {
        this.open = false;
      }
    },
    handleChange(date) {
      this.timeVal = date;
      // this.timeVal = date.map( v => moment(v).valueOf());
      console.log(this.timeVal);
    },
    handleClear() {
      console.log("handleclear");
    },
    handleOk() {
      this.searchFormData[this.rangeTime] = this.timeVal;
      this.rangeTime = false;
      let that = this;
      setTimeout(() => {
        that.searchVisible = true;
      }, 100);
    },
    async getCreateUserOptions(query) {
      let res = await $api.logistics.request("check/createUserOptions", {keyword: null});
      this.createUserOptions = res.data;
    },
    //远程选项设置默认值?
    setDefaultOptions(options, option) {
      this[option] = options;
      debugger;
    },
    maxTagPlaceholder(num) {
      return "更多+ " + num;
    },
    showTempModal() {
      this.$refs.modalTemplate.setExport("0627导入轨迹校验模板.xls");
      this.templateVisible = true;
    },
    impotEvent() {
      this.templateVisible = false;
      this.$refs.xTable
          .readFile({
            types: ["xls", "xlsx"],
          })
          .then((evnt) => {
            showLoading();
            const readData = [];
            const files = evnt.target.files;
            const fileReader = new FileReader();
            fileReader.onload = async (ev) => {
              const data = ev.target.result;
              const workbook = XLSX.read(data, {type: "binary"});
              const csvData = XLSX.utils.sheet_to_csv(Object.values(workbook.Sheets)[0]);
              // 解析数据
              let xlsxData = csvData.split("\n");
              // 删除xlsx列名
              xlsxData.splice(0, 1);
              var error = "";
              for (let i = 0; i < xlsxData.length; i++) {
                const vRow = xlsxData[i];
                if (vRow) {
                  const vCols = vRow.split(",");
                  let item = {
                    carNum: vCols[0], //车牌号
                    vco: this.getColorVal(vCols[1]),
                    beginPlace: vCols[2], //起运地
                    beginTime: getExcelDateHMTimeCheckStart(vCols[3]), //起运时间
                    endPlace: vCols[4], //到达地
                    endTime: getExcelDateHMTimeCheckEnd(vCols[5]), //到达时间
                  };
                  if (isNotEmpty(item.carNum) && isNotEmpty(item.beginPlace)) {
                    readData.unshift(item);
                  }
                  if (isEmpty(item.vco)) {
                    error = "序号" + (i + 1) + ": 无车牌颜色";
                  }
                  if (isNaN(item.beginTime) || isNaN(item.endTime)) {
                    error = "序号" + (i + 1) + ": 时间错误";
                  }
                  if(item.beginTime > item.endTime) {
                  error = "序号" + (i + 1) + ": 结束时同不能小于起始时间";
                }
                  let duration = item.endTime - item.beginTime;
                  if (duration / 86400000 > 5) {
                    error = "序号" + (i + 1) + ": 到达时间-起运时间 > 5天";
                  }
                }
              }

              if (isNotEmpty(error)) {
                this.$XModal.alert({
                  message: error,
                  status: "error",
                });
                return;
              }

              if (isEmpty(readData)) {
                this.$XModal.alert({
                  message: "没有数据",
                  status: "error",
                });
                return;
              }

              let res = await $api.logistics.post("check/importList", [...new Set(readData)]);

              if (res.status === 1) {
                this.$XModal.alert({
                  message: "导入成功,需要校验请点击立即校验",
                  status: "success",
                });
                this.getList();
              } else {
                this.$XModal.alert({
                  message: res.message ? res.message : "接口异常",
                  status: "error",
                });
              }
            };
            fileReader.readAsBinaryString(files[0]);
            setTimeout(() => {
              hideLoading();
            }, 1000);
          });
    },
    getColorVal(txt) {
      if (!txt) return null;
      return $C.CAR_CORLOR['ctype'][txt]
    },
    closeTemplate() {
      this.templateVisible = false;
    },
    refresh() {
      this.getList();
    },
    seeCarMap(row) {
      let that = this;
      let url = "/carShip/fwCarFrame";
      this.fwCar = window.open(url);
      setTimeout(function () {
        that.fwCar.postMessage(JSON.stringify({carInfo: row, logistics: true}), "*");
      }, 2000);
    },
    seeShipMap(row) {
      showLoading();
      let mmsi = row.mmsi ? row.mmsi : row.carShipNum;
      if (mmsi == null || mmsi === "") {
        //暂无数据
        this.$Message.error("暂无数据");
        return;
      }
      let beginTime = moment(row.beginTime).format("YYYY-MM-DD");
      let deliveryDates = moment(row.endTime).format("YYYY-MM-DD");
      let obj = {
        startTime: beginTime + " 00:00:00",
        endTime: deliveryDates + " 00:00:00",
        mmsi: mmsi,
      };
      this.trackFlag = true;
      let that = this;
      if (this.url === "/carShip/fwShipFrame") {
        let mapFrame = that.$refs.mapFrame;
        let iframeWin = mapFrame.contentWindow;
        iframeWin.postMessage(JSON.stringify(obj), "*");
        hideLoading();
      } else {
        this.url = "/carShip/fwShipFrame";
        this.$nextTick(function () {
          setTimeout(function () {
            let mapFrame = that.$refs.mapFrame;
            let iframeWin = mapFrame.contentWindow;
            iframeWin.postMessage(JSON.stringify(obj), "*");
            hideLoading();
          }, 5000);
        });
      }
    },
    // 船舶日期往前推N天
    dateAddDays(dataStr, dayCount) {
      let isdate = new Date(dataStr.replace(/-/g, "/"));
      isdate = new Date((isdate / 1000 - 86400 * dayCount) * 1000); //日期-N天
      let strMonth = isdate.getMonth() + 1;
      let strDate = isdate.getDate();
      let strYear = isdate.getFullYear();
      if (strMonth >= 1 && strMonth <= 9) {
        strMonth = "0" + strMonth;
      }
      if (strDate >= 1 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      return strYear + "-" + strMonth + "-" + strDate;
    },
    async getList(isShowNotCheck) {
      this.loading = true;
      let paramsObj = {};
      paramsObj.pageNum = this.page.currentPage;
      paramsObj.pageSize = this.page.pageSize;
      paramsObj.keyword = this.keyword;
      if (isNotEmpty(this.startTime)) {
        paramsObj.startTime = this.$utils.timestamp(this.startTime);
      }
      if (isNotEmpty(this.endTime)) {
        paramsObj.endTime = this.$utils.timestamp(this.endTime);
      }
      if (isNotEmpty(this.createUserId)) {
        paramsObj.createUserId = this.createUserId;
      }
      this.paramsObj = paramsObj;
      let res = await $api.logistics.request("check/list", paramsObj);
      if (res.status === 1) {
        this.page.totalResult = res.data.total;
        this.tableData = res.data.rows;
        this.countData = JSON.parse(res.data.countData);
        this.loading = false;

        if (isShowNotCheck === true) {
          let currentPath = this.$router.history.current.path;
          if (currentPath === "/logistics/logisticsCheck") {
            this.$XModal.alert({
              message: "剩余未校验: " + this.countData.notCheck + "条",
              status: "success",
            });
          }
          if (this.countData.notCheck === 0) {
            if (isNotEmpty(this.interval)) {
              clearInterval(this.interval);
              this.interval = null;
            }
          }
        }

        this.getCreateUserOptions();
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    async download() {
      if (isEmpty(this.tableData)) {
        this.$XModal.message("暂无数据");
        return;
      }
      showLoading();
      let param = Object.assign({}, this.paramsObj);
      param.pageSize = 100000;
      param.pageNum = 1;
      let res = postBlob("/api/order/logistics/check/exportList", param);
      hideLoading();
      await saveBlob("导出轨迹校验.xls", res.data);
    },
    changePage(e) {
      this.page.currentPage = e.currentPage;
      this.page.pageSize = e.pageSize;
      this.getList();
    },
    footerMethod({columns, data}) {
      let noTrackRate = 0;
      let checkOkRate = 0;
      let changeTimeRate = 0;
      if (isNotEmpty(this.countData.noTrack) && this.countData.noTrack != 0) {
        noTrackRate = (this.countData.noTrack / this.page.totalResult) * 100;
        noTrackRate = noTrackRate.toFixed(2);
      }
      if (isNotEmpty(this.countData.checkOk) && this.countData.checkOk != 0) {
        checkOkRate = (this.countData.checkOk / this.page.totalResult) * 100;
        checkOkRate = checkOkRate.toFixed(2);
      }
      if (isNotEmpty(this.countData.changeTimeRate) && this.countData.changeTimeRate != 0) {
        changeTimeRate = (this.countData.changeTimeRate / this.page.totalResult) * 100;
        changeTimeRate = changeTimeRate.toFixed(2);
      }

      const sums = [];
      columns.forEach((column, columnIndex) => {
        if (columnIndex === 0) {
          sums.push("合计");
        } else {
          let sumCell = null;
          switch (column.property) {
            case "trackUrl":
              sumCell = "无轨迹率 " + noTrackRate + "%";
              break;
            case "checkStatus":
              sumCell = "轨迹匹配率 " + checkOkRate + "%";
              break;
            case "isChangeTime":
              sumCell = "时间修改率 " + changeTimeRate + "%";
              break;
          }
          sums.push(sumCell);
        }
      });
      // 返回一个二维数组的表尾合计
      return [sums];
    },
  },
};
</script>

<style>
@import "../../../src/assets/icon/icon-more/iconfont.css";

.button-gengduo {
  border: none;
}

.button-gengduo:focus {
  outline: none;
  border-color: transparent;
  box-shadow: none;
}

.page-con-header {
  margin-bottom: 10px;
  position: relative;
}

.trackBox {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 100;
  background: #fff;
}
</style>
